import PropTypes from 'prop-types'
import React from 'react'

import CopyEmail from './CopyEmail'
import MemberEmailButton from './MemberEmailButton'
import {ordinalify} from './util'

import './MemberHighlight.css';

const MemberHighlight = ({member, emailSubjectTpl, emailBodyTpl }) => {
  let emailButton = null
  let copyEmail = null
  if (emailSubjectTpl && emailBodyTpl) {
    emailButton = (<div className="MemberHighlight-button-container"><MemberEmailButton member={member} emailSubjectTpl={emailSubjectTpl} emailBodyTpl={emailBodyTpl} /></div>)
    copyEmail = <CopyEmail member={member} emailBodyTpl={emailBodyTpl} />
  }

  return (
    <div className="MemberHighlight">
      <p>Your council member {member.name} ({ordinalify(member.ward)} Ward) is a member of this committee.</p>
      {emailButton}
      {copyEmail}
    </div>
  )
}

MemberHighlight.propTypes = {
  member: PropTypes.object,
  emailSubjectTpl: PropTypes.func,
  emailBodyTpl: PropTypes.func
}

export default MemberHighlight



// WEBPACK FOOTER //
// ./src/MemberHighlight.js